export const serviceEndpoints = {
    verifyCardholder: window?._env_?.API_1,
    validateOtp: window?._env_?.API_2,
    raiseComplaint: window?._env_?.API_3,
    complaintEnquiry: window?._env_?.API_4

};
